export const INFRARED_MIN_VALUE = 200;
export const INFRARED_MAX_VALUE = 1000;
